
const General = {

    footerMenu: function() {
        
        if ($('.footer-links__links')[0]) {
    
            $('footer .footer-block__heading').on('click', function() {

                $(this).parent().toggleClass('open');

            });

        }
    },
    videoPause: function() {
      
        if( $('.js-pauseVideoBtn')[0]) {

  
            $(".js-pauseVideoBtn .pause-btn").click(function() {
                const video = $(this).siblings('.video');

                if (video.get(0).paused) {
                    video.trigger('play');
                    $(this).find('.icon-pause-video').show();
                    $(this).find('.icon-play-video').hide();
                    
                } else {
                    video.trigger('pause');
                    $(this).find('.icon-pause-video').hide();
                    $(this).find('.icon-play-video').show();
                }
            });

        }
        if( $('.js-unmuteVideoBtn')[0]) {

  
            $(".js-unmuteVideoBtn .mute-btn").click(function() {
                const video = $(this).siblings('.video').get(0); // Get the video element

                if (video.muted) {
                    video.muted = false; // Unmute the video
                    $(this).find('.icon-unmute-video').show();
                    $(this).find('.icon-mute-video').hide();
                } else {
                    video.muted = true; // Mute the video
                    $(this).find('.icon-unmute-video').hide();
                    $(this).find('.icon-mute-video').show();
                }
            });

        }
        
    },
    // menuActive: function() {

    //     // $('details.mega-menu').on('click', function() {
    //     //     e.preventDefault();

    //     //     // if( $(this).parent().find('li details[open]')) {
    //     //     //     $(this).parent().parent().parent().addClass('menu-open');
    //     //     //     console.log('menu open')
    //     //     // } else {
    //     //     //     console.log('closed')
    //     //     //     $(this).parent().parent().parent().removeClass('menu-open');

    //     //     // }
    //     // })
    //     let timer;

    //     // $('.header__inline-menu > .list-menu').on('mouseover', function() {
    //     //     timer = setTimeout(function () {
    //     //         $('#desktop-menu-overlay').addClass('menu-open');
    //     //     }, 400);
    //     // })
    //     // $('.header__inline-menu > .list-menu ').on('mouseleave', function() {
    //     //     $('#desktop-menu-overlay').removeClass('menu-open');
    //     //     clearTimeout(timer);
    //     // })
    //     $('.header__inline-menu > .list-menu  .mega-menu__content').on('mouseover', function() {
    //         timer = setTimeout(function () {
    //             $('#desktop-menu-overlay').addClass('menu-open');
    //         }, 400);
    //     })
    //     $('.header__inline-menu > .list-menu .mega-menu__content').on('mouseleave', function() {
    //         $('#desktop-menu-overlay').removeClass('menu-open');
    //         clearTimeout(timer);
    //     })

    // },
    ada: function() {

        setTimeout(() => {
            if ($('.gf-controls-clear-button')[0]) {
                $('.gf-controls-clear-button').attr('aria-label','Clear search');
            }
            if ($('.gf-controls-search-button')[0]) {
                $('.gf-controls-search-button').attr('aria-label','Searh products');
            }
        }, 2000);
    },
    init: function() {
     
        this.footerMenu();
        this.videoPause();
        //this.menuActive();
        this.ada();
    
        if ($('#search-page-results').length) {
            $('head title').text('Search Results - Miyokos Creamery');
        }

    },
};

export default General;